import React from 'react';
import { useTradingViewWidget } from '../hooks/useTradingViewWidget';

export const MARKET_TABS = {
  forex: {
    title: 'Forex',
    symbols: [
      { s: 'FX_IDC:EURUSD', d: 'EUR/USD' },
      { s: 'FX_IDC:USDJPY', d: 'USD/JPY' },
      { s: 'FX_IDC:GBPUSD', d: 'GBP/USD' },
      { s: 'FX_IDC:AUDUSD', d: 'AUD/USD' },
      { s: 'FX_IDC:USDCAD', d: 'USD/CAD' },
      { s: 'FX_IDC:USDCHF', d: 'USD/CHF' }
    ]
  },
  crypto: {
    title: 'Crypto',
    symbols: [
      { s: 'BINANCE:BTCUSDT', d: 'Bitcoin' },
      { s: 'BINANCE:ETHUSDT', d: 'Ethereum' },
      { s: 'BINANCE:BNBUSDT', d: 'BNB' },
      { s: 'BINANCE:SOLUSDT', d: 'Solana' },
      { s: 'BINANCE:XRPUSDT', d: 'XRP' }
    ]
  },
  indices: {
    title: 'Indices',
    symbols: [
      { s: 'FOREXCOM:SPXUSD', d: 'S&P 500' },
      { s: 'FOREXCOM:NSXUSD', d: 'US 100' },
      { s: 'FOREXCOM:DJI', d: 'Dow 30' },
      { s: 'INDEX:DEU40', d: 'DAX 40' },
      { s: 'FOREXCOM:UKXGBP', d: 'FTSE 100' }
    ]
  },
  commodities: {
    title: 'Commodities',
    symbols: [
      { s: 'TVC:GOLD', d: 'Gold' },
      { s: 'TVC:SILVER', d: 'Silver' },
      { s: 'TVC:USOIL', d: 'Crude Oil' },
      { s: 'TVC:UKOIL', d: 'Brent Oil' },
      { s: 'CAPITALCOM:NATURALGAS', d: 'Natural Gas' }
    ]
  }
};

// Parent passes key={category} so the widget remounts with the selected tab
const TradingViewMarketOverview = ({ category = 'forex' }) => {
  const tab = MARKET_TABS[category];
  const containerRef = useTradingViewWidget(
    'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js',
    {
      colorTheme: 'dark',
      dateRange: '1D',
      showChart: true,
      locale: 'en',
      width: '100%',
      height: 560,
      largeChartUrl: '',
      isTransparent: true,
      showSymbolLogo: true,
      showFloatingTooltip: true,
      plotLineColorGrowing: 'rgba(16, 185, 129, 1)',
      plotLineColorFalling: 'rgba(239, 68, 68, 1)',
      gridLineColor: 'rgba(42, 46, 57, 0.06)',
      scaleFontColor: 'rgba(209, 213, 219, 1)',
      belowLineFillColorGrowing: 'rgba(16, 185, 129, 0.12)',
      belowLineFillColorFalling: 'rgba(239, 68, 68, 0.12)',
      belowLineFillColorGrowingBottom: 'rgba(16, 185, 129, 0)',
      belowLineFillColorFallingBottom: 'rgba(239, 68, 68, 0)',
      symbolActiveColor: 'rgba(16, 185, 129, 0.12)',
      tabs: [{ title: tab.title, symbols: tab.symbols, originalTitle: tab.title }]
    }
  );

  return (
    <div
      className="tradingview-widget-container"
      ref={containerRef}
      data-testid={`market-overview-widget-${category}`}
      style={{ height: '560px', width: '100%' }}
    />
  );
};

export default TradingViewMarketOverview;
